export default __webpack_public_path__ + "static/media/NC_256x256_short.9e32458c.png";